import calculArrondi from '@/services/calcul/calculArrondi';
import isNaN from '@/services/general/isNan';

export default function calculTva(devisCommande) {
  if (!devisCommande) {
    return;
  }
  devisCommande.montantTva = 0;
  devisCommande.montantTtc = 0;
  if (!devisCommande.repartitionsTva) {
    return;
  }
  let tva = 0;

  devisCommande.repartitionsTva.forEach((el) => {
    if (!el.totalHt || el.totalHt === undefined || isNaN(el.totalHt)
      || !el.tauxTva || el.tauxTva === undefined || isNaN(el.tauxTva)) {
      el.totalTva = 0;
    } else {
      el.totalTva = calculArrondi(el.totalHt * el.tauxTva / 100);
    }
    tva += el.totalTva;
  });

  devisCommande.montantTva = tva;
  if (devisCommande.montantHt !== undefined) {
    devisCommande.montantTtc = devisCommande.montantHt + devisCommande.montantTva;
  }
}
